export function assertIsNumber(
  variable: any,
  options: { allowNaN: boolean; allowInfinity: boolean } = {
    allowNaN: false,
    allowInfinity: false,
  }
): asserts variable is number {
  if (typeof variable == "number") {
    if (isNaN(variable)) {
      if (options.allowNaN) {
        return;
      }
      throw new Error(
        `Expected variable ${JSON.stringify(
          variable
        )} to be a number! It was instead NaN`
      );
    }

    if (!isFinite(variable)) {
      if (options.allowInfinity) {
        return;
      }
      throw new Error(
        `Expected variable ${JSON.stringify(
          variable
        )} to be a number! It was instead Infinity`
      );
    }
    return;
  } else {
    {
      throw new Error(
        `Expected variable ${JSON.stringify(
          variable
        )} to be a number! It was instead ${typeof variable}`
      );
    }
  }
}
